import {CaretDownOutlined, CaretUpOutlined} from "@ant-design/icons";
import {DoubleCaretIcon} from "@components/icons/Icons";
import React from "react";

const SortIcon = ({sort, sortAsc, sortDesc, onChange}) => {
    return (
        <>
            {sort === sortAsc && (<CaretDownOutlined onClick={() => onChange(sortDesc)} />)}
            {sort === sortDesc && (<CaretUpOutlined onClick={() => onChange(sortAsc)}  />)}
            {(sort !== sortAsc && sort !== sortDesc) && (<DoubleCaretIcon className='sort-icon-double'  onClick={() => onChange(sortAsc)} />)}
        </>
    );
};

export default SortIcon;